import { IconButton, Tooltip } from "@mui/material";

type CustomIconButtonProps = {
  title: string;
  onClick: () => void;
  disabled: boolean;
  icon: React.ReactNode;
};

export const CustomIconButton = ({
  title,
  onClick,
  disabled,
  icon,
}: CustomIconButtonProps) => {
  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          color="secondary"
          sx={{
            marginLeft: "10px",
          }}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};
